export default __webpack_public_path__ + "static/media/astronauta-3.52d1757e.png";